import about from "../../../assets/img/projects/Genome/Genome-about.png";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import React from "react";

gsap.registerPlugin(ScrollTrigger);

function AboutUs() {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 75%",
          end: "bottom top",
          toggleActions: "play none none reverse",
        },
      });

      const img = containerRef.current.querySelector(".about_img");
      const article = containerRef.current.querySelector(".about_text");

      tl.fromTo(
        img,
        { opacity: 0, x: -40, filter: "blur(2px)" },
        {
          opacity: 1,
          x: 0,
          filter: "blur(0px)",
          duration: 0.6,
          ease: "power2.out",
        }
      ).fromTo(
        article,
        { opacity: 0, x: -40, filter: "blur(2px)" },
        {
          opacity: 1,
          x: 0,
          filter: "blur(0px)",
          duration: 0.6,
          ease: "power2.out",
        },
        "-=0.4"
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="Genome-about" ref={containerRef}>
      <img className="about_img" src={about} alt="About Genome" />
      <article className="about_text">
        <h1>{t("genome.about.title")}</h1>
        {t("genome.about.text")
          .split("\n")
          .map((para, i) => (
            <p key={i}>
              {para.split("\n").map((line, j) => (
                <React.Fragment key={j}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          ))}
      </article>
    </div>
  );
}

export default AboutUs;
